import { render, staticRenderFns } from "./Consent.vue?vue&type=template&id=def8e386&scoped=true"
import script from "./Consent.vue?vue&type=script&lang=js"
export * from "./Consent.vue?vue&type=script&lang=js"
import style0 from "./Consent.vue?vue&type=style&index=0&id=def8e386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def8e386",
  null
  
)

export default component.exports